import cx from "classnames";

import { AccountViewer } from "components/form/graphql/types";
import Typography from "ds/components/Typography";
import Box from "ds/components/Box";
import TextEllipsis from "ds/components/TextEllipsis";

import styles from "./styles.module.css";

type UserCardProps = {
  accountName: string;
  viewer: AccountViewer;
  transitionClasses?: string;
  isSidebarExpanded?: boolean;
};

const MainNavigationUserCard = ({
  accountName,
  viewer,
  transitionClasses,
  isSidebarExpanded,
}: UserCardProps) => {
  return (
    <Box
      title={viewer.name}
      align="center"
      className={cx(styles.userCard, isSidebarExpanded && styles.expanded)}
      gap="medium"
      fullWidth
      zeroMinWidth
    >
      <img className={styles.avatar} src={viewer.avatarURL} alt="Avatar" />

      <Box direction="column" align="start" justify="start" fullWidth zeroMinWidth>
        <TextEllipsis tooltip={viewer.name}>
          {({ className, ...props }) => (
            <Typography
              {...props}
              className={cx(styles.name, transitionClasses, className)}
              tag="span"
            >
              {viewer.name}
            </Typography>
          )}
        </TextEllipsis>

        <TextEllipsis tooltip={accountName}>
          {({ className, ...props }) => (
            <Typography
              {...props}
              tag="span"
              className={cx(styles.details, transitionClasses, className)}
              color="secondary"
            >
              {accountName}
            </Typography>
          )}
        </TextEllipsis>
      </Box>
    </Box>
  );
};

export default MainNavigationUserCard;
